module.exports = __webpack_public_path__ + "img/green-2-squiggly-open.a4e13c21.svg";